import React, { useEffect, useState } from "react";
import styles from "./SelectTerm.module.scss";
import { SonicTermData } from "../classes/SonicTerm";
import SaveButton from "../nav/SaveButton";
import SelectTermItem from "./SelectTermItem";
import { TermType, useGetTerm } from "../../utils/useTerm";
import SearchTermInput from "./SearchTermInput";
import LoadingSpinner from "../LoadingSpinner";
import SonicLink from "../routing/SonicLink";

type Props = {
  termType: TermType;
  termName: string;
  buttonText: string;
  terms: Array<SonicTermData>;
  handleTerms: (value: Array<SonicTermData>) => void;
  isAdminPage?: boolean;
  maximumNumber?: number;
  buttonClass?: string;
};
const SelectMultipleTerms: React.FC<Props> = ({
  termType,
  termName,
  buttonText,
  terms,
  handleTerms,
  isAdminPage = false,
  maximumNumber,
  buttonClass,
}) => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  const [selectedTerms, setSelectedTerms] = useState<Array<SonicTermData>>([
    ...terms,
  ]);
  const [keyword, setKeyword] = useState<string>("");
  const [searchWord, setSearchWord] = useState<string>();

  const {
    termData: { entries },
    getTermLoading,
  } = useGetTerm(termType, undefined, -1, searchWord);

  const checkHandler = (checked: boolean, value: SonicTermData) => {
    const terms = selectedTerms;
    if (checked === true) {
      if (terms.findIndex((t) => t.id === value.id) < 0) {
        const number = entries.findIndex((o) => o.id === value.id);
        terms.splice(number, 0, { ...value });
      }
      setSelectedTerms([...terms]);
    } else {
      setSelectedTerms([...terms.filter((t) => t.id !== value.id)]);
    }
  };

  const updateHandler = () => {
    if (JSON.stringify(terms) !== JSON.stringify(selectedTerms)) {
      handleTerms(selectedTerms);
    }
  };

  const [confirmInput, setConfirmInput] = useState<boolean>(true);
  const handleKeys = (event: React.KeyboardEvent<HTMLInputElement>) => {
    switch (event.key) {
      case "Enter":
        if (confirmInput) {
          event.preventDefault();
          setSearchWord(keyword);
        }
        break;
      default:
        break;
    }
  };

  const checkDisabledHandler = (
    selected: Array<SonicTermData>,
    option: SonicTermData
  ) => {
    if (selected.findIndex((s) => s.id === option.id) >= 0) {
      return false;
    } else {
      return true;
    }
  };

  const clearSearch = () => {
    setKeyword("");
    setSearchWord(undefined);
  };

  return (
    <>
      <SaveButton
        wrapperClass={buttonClass}
        title={buttonText}
        onClick={() => setModal(true)}
      />
      {isModalShown ? (
        <div className={`${styles["select-term__modal"]} ${styles["open"]}`}>
          {maximumNumber ? (
            <div className={styles["select-term__modal-introBox"]}>
              <p>{`${termName}を選択してください。`}</p>
              <p
                className={styles["select-term__modal-introBox__select-count"]}
              >{`現在${selectedTerms.length}個選択中（最大${maximumNumber}個まで）`}</p>
            </div>
          ) : (
            <p className={styles["select-term__modal-intro"]}>
              {`${termName}を選択してください。(複数選択可)`}
            </p>
          )}
          {getTermLoading ? (
            <LoadingSpinner space={1} />
          ) : (
            <>
              <SearchTermInput
                termName={termName}
                keyword={keyword}
                handleKeys={handleKeys}
                setKeyword={setKeyword}
                setConfirmInput={setConfirmInput}
                handleSearch={() => {
                  setSearchWord(keyword ? keyword : undefined);
                }}
                clearSearch={clearSearch}
              />
              <div className={styles["select-term__modal-area"]}>
                {entries
                  ? entries.map((option, i) => (
                      <SelectTermItem
                        key={i}
                        type="checkbox"
                        terms={terms}
                        term_option={option}
                        checkHandler={checkHandler}
                        checked={
                          selectedTerms.findIndex((t) => t.id === option.id) !==
                          -1
                        }
                        disabled={
                          maximumNumber && selectedTerms.length >= maximumNumber
                            ? checkDisabledHandler(selectedTerms, option)
                            : false
                        }
                      />
                    ))
                  : null}
              </div>
            </>
          )}
          <div className={styles["select-term__modal__bottom"]}>
            <button
              type="button"
              className={styles["select-term__modal__bottom-fix"]}
              onClick={() => {
                updateHandler();
                clearSearch();
                setModal(false);
              }}
            >
              確定する
            </button>
            <button
              type="button"
              className={styles["select-term__modal__bottom-back"]}
              onClick={() => {
                setSelectedTerms([...terms]);
                clearSearch();
                setModal(false);
              }}
            >
              キャンセル
            </button>
            {!isAdminPage && (
              <div className={styles["select-term__modal__bottom-help"]}>
                {termName === "チーム" ? (
                  <SonicLink to="/mypage/team-settings" newTab={true}>
                    {"チームの新規登録はこちらから"}
                  </SonicLink>
                ) : (
                  <SonicLink to="/contact" newTab={true}>
                    {`ご希望の${termName}がない方はこちら`}
                  </SonicLink>
                )}
              </div>
            )}
          </div>
        </div>
      ) : null}
    </>
  );
};

export default SelectMultipleTerms;
